import React, { useEffect, useContext, useState } from "react";
import Footer from "../../component/footer";
import { SidebarContext } from "../../component/Context/SidebarContext";
// import { GamePopupContext } from "../../component/Context/GamePopupContext";
import "./Games.css";
import { useNavigate } from "react-router-dom";
import { FetchGames } from "../../GameServices/GameServices";
import { motion } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";
import Button from "../../component/Button/Button";
import "../../new-app.css";

function Games() {
  const { dispatch } = useContext(SidebarContext);
  const [gamesList, setGamesList] = useState([]);
  const [hover, setHover] = useState();
  const [glory, setGlory] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: "SEARCH_BTN", data: true });
    return function () {
      dispatch({ type: "SEARCH_BTN", data: false });
    };
  }, []);

  const playGameHandler = (gameName) => {
    navigate(`/playgame/${gameName}`);
  };

  const onHover = (param) => {
    setHover(param);
  };
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  useEffect(() => {
    fetchGames();
    const Interval = setInterval(() => {
      setGlory(randomIntFromInterval(0, 21));
    }, 2000);
    return () => {
      clearInterval(Interval);
    };
  }, []);
  const fetchGames = async () => {
    let { data } = await FetchGames();
    setGamesList(data);
  };

  return (
    <div className='main-screen2'>
      <LazyMotion features={domAnimation}>
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}>
          {/* <section className="games-section">
          <div className="container-1280">
            <div className="row games-row">
              <div className="col-lg-12">
                <div className="images-row">
                  <div className="images-col">
                    <img
                      src={
                        hover === 0
                          ? require("../../Assets/img/tetris.gif")
                          : require("../../Assets/img/game1.png")
                      }
                      alt="Game"
                      onClick={() => {
                        playGameHandler("tetris");
                      }}
                      onMouseEnter={() => onHover(0)}
                      onMouseLeave={() => setHover("")}
                    />
                  </div>

                  <div className="images-col">
                    <img
                      src={
                        hover === 1
                          ? require("../../Assets/img/ageofstack.gif")
                          : require("../../Assets/img/game-2.jpg")
                      }
                      alt="Game"
                      onClick={() => {
                        playGameHandler("stack");
                      }}
                      onMouseEnter={() => onHover(1)}
                      onMouseLeave={() => setHover("")}
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game3.jpg")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={
                        hover === 2
                          ? require("../../Assets/img/2048.gif")
                          : require("../../Assets/img/game4.png")
                      }
                      alt="Game"
                      onClick={() => {
                        playGameHandler("2048");
                      }}
                      onMouseEnter={() => onHover(2)}
                      onMouseLeave={() => setHover("")}
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game5.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game6.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game7.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game8.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={
                        hover === 3
                          ? require("../../Assets/img/roadfighter.gif")
                          : require("../../Assets/img/game9.png")
                      }
                      alt="Game"
                      onClick={() => {
                        playGameHandler("road");
                      }}
                      onMouseEnter={() => onHover(3)}
                      onMouseLeave={() => setHover("")}
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game10.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game11.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game12.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game13.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game14.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img
                      src={require("../../Assets/img/game15.png")}
                      alt="Game"
                    />
                  </div>
                  <div className="images-col">
                    <img src={require("../../Assets/img/game16.png")} alt="" />
                  </div>
                  <div className="images-col bubble-shooter">
                    <img
                      src={
                        hover === 4
                          ? require("../../Assets/img/bubbleShooter.gif")
                          : require("../../Assets/img/game17.png")
                      }
                      alt="Game"
                      onClick={() => {
                        playGameHandler("BubbleShooter");
                      }}
                      onMouseEnter={() => onHover(4)}
                      onMouseLeave={() => setHover("")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
          <section className='games-section no-before'>
            <div className='container-1280 games-container hz-game-contain'>
              {/* <div className="row games-row">
                <div className="col-lg-12">
                  <div className="images-row">
                    <div className="row"></div>
                    <div className="col-one-item">
                      <div className="images-col hotgame">
                        <img
                          src={
                            hover === 0
                              ? require("../../Assets/img/tetris.gif")
                              : require("../../Assets/img/game1.png")
                          }
                          alt="Game"
                          onClick={() => {
                            playGameHandler("tetris");
                          }}
                          onMouseEnter={() => onHover(0)}
                          onMouseLeave={() => setHover("")}
                        />
                      </div>
                    </div>
                    <div className="col-two-item">
                      <div className="images-col h-50">
                        <img
                          src={
                            hover === 1
                              ? require("../../Assets/img/ageofstack.gif")
                              : require("../../Assets/img/game-2.jpg")
                          }
                          alt="Game"
                          onClick={() => {
                            playGameHandler("stack");
                          }}
                          onMouseEnter={() => onHover(1)}
                          onMouseLeave={() => setHover("")}
                        />
                      </div>
                      <div className="images-col h-50">
                        <img
                          src={require("../../Assets/img/game3.jpg")}
                          alt="Game"
                        />
                      </div>
                    </div>
                    <div className="col-one-item">
                      <div className="images-col">
                        <img
                          src={
                            hover === 2
                              ? require("../../Assets/img/2048.gif")
                              : require("../../Assets/img/game4.png")
                          }
                          alt="Game"
                          onClick={() => {
                            playGameHandler("2048");
                          }}
                          onMouseEnter={() => onHover(2)}
                          onMouseLeave={() => setHover("")}
                        />
                      </div>
                    </div>

                    <div className="col-two-item">
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game5.png")}
                          alt="Game"
                        />
                      </div>
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game6.png")}
                          alt="Game"
                        />
                      </div>
                    </div>

                    <div className="col-two-item">
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game7.png")}
                          alt="Game"
                          onClick={() => {
                            playGameHandler("FruitNinja");
                          }}
                        />
                      </div>
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game8.png")}
                          alt="Game"
                        />
                      </div>
                    </div>

                    <div className="col-one-item ">
                      <div className="images-col hotgame">
                        <img
                          src={
                            hover === 3
                              ? require("../../Assets/img/roadfighter.gif")
                              : require("../../Assets/img/game9.png")
                          }
                          alt="Game"
                          onClick={() => {
                            playGameHandler("road");
                          }}
                          onMouseEnter={() => onHover(3)}
                          onMouseLeave={() => setHover("")}
                        />
                      </div>
                    </div>

                    <div className="col-two-item">
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game10.png")}
                          alt="Game"
                        />
                      </div>
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game11.png")}
                          alt="Game"
                        />
                      </div>
                    </div>

                    <div className="col-one-item ">
                      <div className="images-col hotgame">
                        <img
                          src={require("../../Assets/img/game12.png")}
                          alt="Game"
                        />
                      </div>
                    </div>

                    <div className="col-two-item">
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game13.png")}
                          alt="Game"
                        />
                      </div>
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game14.png")}
                          alt="Game"
                        />
                      </div>
                    </div>

                    <div className="col-two-item">
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game15.png")}
                          alt="Game"
                        />
                      </div>
                      <div className="images-col">
                        <img
                          src={require("../../Assets/img/game16.png")}
                          alt=""
                        />
                      </div>
                    </div>

                    <div className="col-one-item long-item">
                      <div className="images-col bubble-shooter">
                        <img
                          src={
                            hover === 4
                              ? require("../../Assets/img/bubbleShooter.gif")
                              : require("../../Assets/img/game17.png")
                          }
                          alt="Game"
                          onClick={() => {
                            playGameHandler("BubbleShooter");
                          }}
                          onMouseEnter={() => onHover(4)}
                          onMouseLeave={() => setHover("")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className='row games-row'>
                <div className='col-12'>
                  <div className='images-row'>
                    <div className='row'>
                      <div className='col-5 p-xs-0'>
                        <div
                          className={`game-big-box ${
                            glory === 1 ? "animate-glory" : ""
                          }`}>
                          <img
                            // src={
                            //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                            // }
                            src={gamesList[0]?.thumbnail}
                            alt='Game'
                            onClick={() => {
                              playGameHandler(gamesList[0]?.name);
                            }}
                            onMouseEnter={() => onHover(1)}
                            onMouseLeave={() => setHover("")}
                          />
                          <span>{gamesList[0]?.gameBuild}</span>
                        </div>
                      </div>
                      <div className='col-7'>
                        <div className='row'>
                          <div className='col-6'>
                            <div className='game-md-box'>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[1]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[1]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[1]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-6'>
                            <div
                              className={`game-md-box ${
                                glory === 3 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[2]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[2]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[2]?.gameBuild}</span>
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-4'>
                            <div
                              className={`game-sm-box ${
                                glory === 4 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[3]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[3]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[3]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-4 p-xs-0'>
                            <div
                              className={`game-sm-box ${
                                glory === 5 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[4]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[4]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[4]?.gameBuild}</span>
                            </div>
                          </div>

                          <div className='col-4'>
                            <div
                              className={`game-sm-box ${
                                glory === 6 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[5]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[5]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[5]?.gameBuild}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-8 '>
                        <div className='row'>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 7 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[6]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[6]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[6]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 8 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[7]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[7]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[7]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 9 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[8]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[8]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[8]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 10 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[9]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[9]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[9]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 11 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[10]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[10]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[10]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 12 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[11]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[11]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[11]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 13 ? "animate-glory" : ""
                              }`}>
                              <img
                                // src={
                                //   hover === 1 ? require("../../Assets/img/ageofstack.gif") : require("../../../src/Assets/img/age-stake.png")
                                // }
                                src={gamesList[12]?.thumbnail}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler(gamesList[12]?.name);
                                }}
                                onMouseEnter={() => onHover(1)}
                                onMouseLeave={() => setHover("")}
                              />
                              <span>{gamesList[12]?.gameBuild}</span>
                            </div>
                          </div>
                          <div className='col-3'>
                            <div
                              className={`game-xs-box ${
                                glory === 14 ? "animate-glory" : ""
                              }`}>
                              <img
                                src={require("../../../src/Assets/img/game16.png")}
                                alt=''
                              />
                              <span>Ludo Club</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div
                          className={`game-medbox-2 ${
                            glory === 15 ? "animate-glory" : ""
                          }`}>
                          <img
                            src={require("../../../src/Assets/img/game12.png")}
                            alt='Game'
                            onClick={() => {
                              playGameHandler("Pacman");
                            }}
                          />
                          <span>PAC-MAN</span>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-4'>
                        <div
                          className={`game-medbox-2 ${
                            glory === 16 ? "animate-glory" : ""
                          }`}>
                          <img
                            src={require("../../../src/Assets/img/flappy.png")}
                            alt='Game'
                            onClick={() => {
                              playGameHandler("flappybirds");
                            }}
                          />
                          <span>Flappy Birds</span>
                        </div>
                      </div>
                      <div className='col-4 p-xs-0'>
                        <div className='row'>
                          <div className='col-6'>
                            <div
                              className={`game-xs-box ${
                                glory === 17 ? "animate-glory" : ""
                              }`}>
                              <img
                                src={require("../../../src/Assets/img/game13.png")}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler("DinoJump");
                                }}
                              />
                              <span>Dino Run</span>
                            </div>
                          </div>
                          <div className='col-6'>
                            <div
                              className={`game-xs-box ${
                                glory === 18 ? "animate-glory" : ""
                              }`}>
                              <img
                                src={require("../../../src/Assets/img/game5.png")}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler("Hillclimbracing");
                                }}
                              />
                              <span>Hill Climb</span>
                            </div>
                          </div>
                          <div className='col-6'>
                            <div
                              className={`game-xs-box ${
                                glory === 19 ? "animate-glory" : ""
                              }`}>
                              <img
                                src={require("../../../src/Assets/img/game6.png")}
                                alt='Game'
                                onClick={() => {
                                  playGameHandler("PaperToss");
                                }}
                              />
                              <span>Paper Toss</span>
                            </div>
                          </div>
                          <div className='col-6'>
                            <div
                              className={`game-xs-box ${
                                glory === 20 ? "animate-glory" : ""
                              }`}>
                              <img
                                src={require("../../../src/Assets/img/gun.png")}
                                alt='Game'
                              />
                              <span>Sniper 3D</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div
                          className={`game-medbox-2 ${
                            glory === 21 ? "animate-glory" : ""
                          }`}>
                          <img
                            src={require("../../../src/Assets/img/jumpball.png")}
                            alt='Game'
                            onClick={() => {
                              playGameHandler("HelixJump");
                            }}
                          />
                          <span>Helix Jump</span>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-one-item" key={1}>
                   
                    
                  </div>
                  <div className="col-two-item col-two-item-height" key={2}>
                    
                    
                  </div>
                  <div className="col-one-item" key={3}>
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={4}>
                    
                   
                  </div>

                  <div className="col-two-item col-two-item-height" key={5}>
                    
                    
                  </div>

                  <div className="col-one-item " key={6}>
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={7}>
                    
                    
                  </div>

                  <div className="col-one-item" key={8}>
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={9}>
                    
                    
                  </div>

                  <div className="col-two-item col-two-item-height" key={10}>
                   
                    
                  </div>

                  <div className="col-one-item long-item" key={11}>
                    
                  </div> */}
                  </div>
                </div>
              </div>
              <Button className='animate-glory' value='Load more...' />
            </div>
          </section>

          <section className='join-text-section'>
            <div className='container-1280'>
              <div className='row'>
                <div className='col-lg-12'>
                  <h3>Join Our</h3>
                  <h2>Ecosystem With Over</h2>
                  <h4>400K Montly User</h4>
                  <h2 className='active-user'>
                    <span className='monkey'>
                      <img
                        src={require("../../Assets/img/monkey1.png")}
                        alt='icon'
                      />
                    </span>
                    Active User
                    <span className='women'>
                      <img
                        src={require("../../Assets/img/women1.png")}
                        alt='icon'
                      />
                    </span>
                  </h2>

                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className='explore-games'>
            <div className='container-1280'>
              <div className='row'>
                <div className='col-lg-6'>
                  <h3>Explore</h3>
                  <h2>Our Games</h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book
                  </p>
                </div>
                <div className='col-lg-6'>
                  <img src={require("../../Assets/img/games.png")} alt='icon' />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </motion.div>
      </LazyMotion>
    </div>
  );
}
export default Games;
